(() => {
  const sections = document.querySelectorAll('.reels-section');
  if (!sections.length) return;

  const modal = document.querySelector('[data-reel-modal]');
  const modalVideo = modal?.querySelector('[data-reel-modal-video]');
  const modalClose = modal?.querySelector('[data-reel-close]');

  const supportsDialog = modal && typeof modal.showModal === 'function';

  const openModal = (videoEl) => {
    if (!modal || !modalVideo || !videoEl) return;
    const sources = videoEl.querySelectorAll('source');
    modalVideo.innerHTML = '';
    sources.forEach((src) => {
      const clone = document.createElement('source');
      clone.src = src.src;
      clone.type = src.type;
      modalVideo.appendChild(clone);
    });
    modalVideo.load();
    if (supportsDialog) {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    modalVideo.muted = false;
    modalVideo.play().catch(() => {});
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    if (!modal || !modalVideo) return;
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.innerHTML = '';
    if (supportsDialog && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
    document.body.style.overflow = '';
  };

  modalClose?.addEventListener('click', closeModal);
  modal?.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });
  modal?.addEventListener('cancel', (e) => {
    e.preventDefault();
    closeModal();
  });

  sections.forEach((section) => {
    const track = section.querySelector('[data-reels-track]');
    const prevBtn = section.querySelector('[data-reels-prev]');
    const nextBtn = section.querySelector('[data-reels-next]');
    const cards = section.querySelectorAll('[data-reel-card]');

    cards.forEach((card) => {
      const video = card.querySelector('[data-reel-video]');
      const openBtn = card.querySelector('[data-reel-open]');
      openBtn?.addEventListener('click', () => openModal(video));
    });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('[data-reel-video]');
            if (!video) return;
            if (entry.isIntersecting && entry.intersectionRatio > 0.55) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.55, 1] }
      );
      cards.forEach((card) => io.observe(card));
    }

    if (track && prevBtn && nextBtn) {
      const updateNavState = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 4) {
          prevBtn.hidden = true;
          nextBtn.hidden = true;
          return;
        }
        prevBtn.hidden = false;
        nextBtn.hidden = false;
        prevBtn.disabled = track.scrollLeft <= 4;
        nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
      };

      const scrollByCard = (dir) => {
        const card = track.querySelector('[data-reel-card]');
        if (!card) return;
        const cardWidth = card.getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(track).columnGap || '16');
        track.scrollBy({ left: dir * (cardWidth + gap), behavior: 'smooth' });
      };

      prevBtn.addEventListener('click', () => scrollByCard(-1));
      nextBtn.addEventListener('click', () => scrollByCard(1));
      track.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      requestAnimationFrame(updateNavState);
    }
  });
})();
